import styled from "styled-components";
import { THEME } from 'THEME';

export const CheckBoxContentCheck = styled.div`
  display: flex;
  align-self: flex-start;
  flex: 1 1 40%;
  max-width: 340px;
  margin-bottom: 12px;
  align-items: center;
`;

export const CheckBoxContentCheckIcon = styled.div`
  margin-right: 10px;
  min-width: 24px;
  max-width: 24px;
  height: 24px;
  padding: 6px;
  background-color: #537EE7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CheckBoxContentCheckName = styled.span`
  font-size: 16px;
  line-height: 24px;
  @media(min-width: 960px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const CheckBoxContentDescription = styled.p`
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 20px;
  color: #3F5366;
  &:last-child {
    margin-bottom: 0;
  }
  @media(min-width: 960px) {
    margin-top: -6px;
    font-size: 16px;
    line-height: 24px;
  }
`